import '@images/i-menu.png';
import '@styles/app.scss';

/**
 * App script
 */

import ICRASFront from '@scripts/controllers/Front';

document.addEventListener('DOMContentLoaded', () => {
  let controller = new ICRASFront();
  controller.boot();
});
